<template>
	<div :class="['overlay', overlayClass]">
		<div class="modal">
			<component :is="componentName" v-bind="data" v-if="isActive" />
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import BudgetInfoPopup from "@/components/game/budget/BudgetInfoPopup";
import SidebarInfoPopup from "@/components/game/sidebar/SidebarInfoPopup";

export default {
	name: 'ModalOverlay',
	components: {
		BudgetInfoPopup,
		SidebarInfoPopup,
	},
	computed: {
		...mapState("global/modal", {
			overlayClass: (state) => state.class,
			componentName: (state) => state.component,
			isActive: (state) => state.active,
			data: (state) => state.data,
		}),
	},
};
</script>

<style lang="scss" scoped>
	.overlay {
		align-items: center;
		background: rgba(0, 0, 0, .5);
		display: flex;
		height: 100%;
		justify-content: center;
		position: absolute;
		top: 0;
		width: 100%;
		z-index: $z-top;

		&.full-width { width: 100vw; }
	}

	.modal {
		height: 100%;
		width: calc(100% - #{$sidebar-mobile-width});
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 0;

		@include tablet {
			width: calc(100% - #{$sidebar-width});
			position: absolute;
			right: 0;
		}

		@include desktop {
			width: 100%;
			position: relative;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/partials/ModalOverlay.vue